import { filterQueriedRoles } from './filterQueriedRoles';
import { getWarningFlags } from './getWarningFlags';
import { getWarnings } from './getWarnings';
import type { IUseGrantableRolesArgs } from './typings';
import { useRolesQuery } from './useRolesQuery';

export function useGrantableRoles(args: IUseGrantableRolesArgs) {
  const { scopeQueriesResult } = args;

  const rolesQueryResult = useRolesQuery(args);
  const grantableRoles = rolesQueryResult.roles;

  const warningFlags = getWarningFlags(args);
  const warnings = getWarnings({
    grantableRoles,
    warningFlags,
    organizations: scopeQueriesResult.organizations || [],
  });

  const filteredRoles = filterQueriedRoles(
    grantableRoles,
    args.permissionScope,
    warningFlags,
  );

  return {
    warnings,
    roles: filteredRoles,
    loading: scopeQueriesResult.loading || rolesQueryResult.loading,
  };
}
